import { Check, ArrowRight, Clock } from "lucide-react";
import { PRICING } from "@/data";
import { Reveal, LeafDivider } from "@/components/Reveal";

export const Pricing = () => (
  <section id="tarieven" className="py-24 lg:py-28 bg-brand-paper border-y border-brand-gold/15">
    <div className="max-w-7xl mx-auto px-6 lg:px-10">
      <Reveal className="text-center mb-14">
        <LeafDivider label="Sessies & Tarieven" />
        <h2 className="font-display text-4xl sm:text-5xl text-brand-forest mt-3">Workshops & tarieven</h2>
        <p className="font-body text-brand-inkSoft max-w-xl mx-auto mt-4 text-lg">
          Vanaf 4 januari starten de Freedom workshops. Geen online boeking — neem persoonlijk contact met ons op en we stemmen samen af wat bij jou past.
        </p>
      </Reveal>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {PRICING.map((p, i) => (
          <Reveal key={p.name} delay={i * 0.1}>
            <div
              data-testid={`pricing-card-${i}`}
              className={`rounded-2xl p-8 h-full flex flex-col border ${
                p.featured
                  ? "bg-brand-forest text-brand-cream border-brand-gold shadow-2xl md:-translate-y-3"
                  : "card-soft text-brand-ink"
              }`}
            >
              {p.featured && <span className="self-start eyebrow !text-brand-goldLight mb-2">Meest gekozen</span>}
              <h3 className={`font-display text-2xl ${p.featured ? "text-brand-cream" : "text-brand-forest"}`}>{p.name}</h3>
              <div className="flex items-baseline gap-2 mt-4">
                <span className={`font-display text-5xl ${p.featured ? "text-brand-goldLight" : "text-brand-sage"}`}>{p.price}</span>
                <span className={`font-body text-sm ${p.featured ? "text-brand-cream/70" : "text-brand-inkSoft"}`}>{p.unit}</span>
              </div>
              <p className={`flex items-center gap-2 mt-3 font-body text-sm ${p.featured ? "text-brand-goldLight" : "text-brand-sage"}`}>
                <Clock size={15} /> Duur: {p.duration}
              </p>
              <p className={`font-body text-sm mt-5 leading-relaxed flex-1 ${p.featured ? "text-brand-cream/85" : "text-brand-inkSoft"}`}>
                {p.desc}
              </p>
              <a
                href="#contact"
                data-testid={`pricing-contact-${i}`}
                className={`mt-7 inline-flex items-center justify-center gap-2 px-6 py-3 rounded-full text-xs uppercase tracking-[0.15em] transition-all ${
                  p.featured ? "bg-brand-goldLight text-brand-forestDeep hover:bg-brand-gold" : "bg-brand-sage/15 text-brand-forest hover:bg-brand-sage hover:text-white"
                }`}
              >
                Neem contact op <ArrowRight size={14} />
              </a>
            </div>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.2}>
        <p className="text-center font-display text-3xl sm:text-4xl text-brand-sage italic mt-16 leading-snug max-w-2xl mx-auto">
          “Rust leeft al in jou. Het is geen plek die je zoekt, maar een plek die je herinnert.”
        </p>
      </Reveal>
    </div>
  </section>
);
